<template>
  <div class="menus-page display-col">
    <table-con>
      <div slot="breadcrumb">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/orders' }"
            >首页</el-breadcrumb-item
          >
          <el-breadcrumb-item>系统管理</el-breadcrumb-item>
          <el-breadcrumb-item>菜单管理</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div slot="table" class="full-height display-col">
        <el-row class="flex1 overflowAuto">
          <el-col :span="8" class="menu-list-container">
            <div class="menu-list">
              <div
                class="newAdd"
                style="display: flex; justify-content: flex-end"
              >
                <el-button
                  class="btnText"
                  type="text"
                  size="mini"
                  @click="() => append(data)"
                >
                  添加
                </el-button>
              </div>

              <el-tree
                :data="data"
                node-key="id"
                :props="defaultProps"
                :expand-on-click-node="false"
                :check-on-click-node="true"
                :highlight-current="true"
                @node-drag-end="handleDragEnd"
              >
                <div style="width: 100%" slot-scope="{ node, data }">
                  <div class="custom-tree-node">
                    <div class="flex-1" @click="() => selectedNode(node, data)">
                      <span>{{ node.label }}</span>
                    </div>
                    <el-button
                      v-if="data.level != 2"
                      type="text"
                      size="mini"
                      @click="() => append(data)"
                    >
                      添加
                    </el-button>
                  </div>
                </div>
              </el-tree>
            </div>
          </el-col>
          <el-col :span="16">
            <div class="menu-form">
              <el-form
                :rules="rules"
                :model="formData"
                ref="menuForm"
                label-width="120px"
                label-position="left"
                class="menu-form"
                style="max-width: 500px"
              >
                <div style="padding: 15px; font-size: 15px">
                  类目<span v-if="isEdit">修改</span><span v-else>新增</span>
                </div>
                <el-form-item prop="parentName" label="父节点:" v-if="!isEdit">
                  <el-input
                    v-model="formData.parentName"
                    disabled
                    size="small"
                  ></el-input>
                </el-form-item>
                <el-form-item label="类目名称:" prop="name">
                  <el-input v-model="formData.name" size="small"></el-input>
                </el-form-item>
                <el-form-item label="类目顺序:" prop="sort">
                  <el-input-number
                    style="width: 100%"
                    :min="0"
                    v-model="formData.sort"
                    size="small"
                  />
                </el-form-item>
                <el-form-item label="删除状态：" v-if="isEdit">
                  <!-- {{ isDelMenu }} -->
                  <el-checkbox v-model="isDelMenu" @change="delMenu()"
                    >选中为删除</el-checkbox
                  >
                  <!-- {{ this.isDelMenu }}
                  {{ formData.delFlag }} -->
                </el-form-item>
                <div class="save-btn-container">
                  <el-button class="form-btn btn-gray" @click="formReset"
                    >重 置</el-button
                  >
                  <el-button class="form-btn btn-blue" @click="formSave"
                    >提 交</el-button
                  >
                </div>
              </el-form>
            </div>
          </el-col>
        </el-row>
      </div>
    </table-con>
  </div>
</template>

<script>
import { treeDataTranslate, listToTree } from "@/class/utils";
export default {
  data() {
    return {
      data: [],
      defaultProps: {
        children: "children",
        label: "name",
        id: "createUserId",
      },
      menuForm: {},
      isEdit: false,
      formData: {
        parentId: undefined, //父ID
        name: undefined, //分类名称
        level: undefined, //级别
        sort: undefined, //排序
        delFlag: undefined, //是否删除
      },
      selectedNodeData: {},
      dialogVisible: false,
      // menuBtnAuth:[],
      menuBtnAuthOrgin: [],
      isDelMenu: false,
      rules: {
        // parentName: [
        //   { required: true, message: "请输入父节点", trigger: "blur" },
        // ],
        name: [{ required: true, message: "请输入类目名称", trigger: "blur" }],
        sort: [{ required: true, message: "请输入排序", trigger: "blur" }],
      },
    };
  },
  methods: {
    append(data) {
      console.log("data", data);
      this.isEdit = false;
      this.formData = {
        parentName: data.name,
        parentId: data.id,
        default: "0",
        level: data._level || 0,
      };
      console.log(this.formData, "formData");
      // this.formData.parentName = data.name
      // this.formData.parentId = data.createUserId
      // this.formData.name  = undefined
      // this.formData.id = undefined
      // this.default = 0
    },

    remove(node, data) {
      const parent = node.parent;
      const menuTreeChild = parent.data.menuTreeChild || parent.data;
      const index = menuTreeChild.findIndex((d) => d.menuId === data.menuId);
      menuTreeChild.splice(index, 1);
    },
    selectedNode(node, data) {
      this.isEdit = true;
      var _this = this;
      this.selectedNodeData = JSON.parse(JSON.stringify(data));
      if (this.selectedNodeData.btnAuth) {
        this.selectedNodeData.btnAuth.forEach((el) => {
          _this.$set(el, "isEdit", false);
        });
      }
      // var info = JSON.parse(JSON.stringify(this.selectedNodeData));
      this.formData = { ...this.selectedNodeData };
    },
    handleDragEnd(e) {
      console.log("end");
      console.log(this.data);
    },
    dialogShow() {
      var _this = this;
      this.dialogVisible = true;
      if (this.menuInfo.btnAuth && this.menuInfo.btnAuth.length > 0) {
        this.menuInfo.btnAuth.forEach((el) => {
          el.isEdit = false;
        });
      }
      if (this.menuInfo.btnAuth && this.menuInfo.btnAuth.length > 0) {
        this.menuBtnAuthOrgin = JSON.parse(
          JSON.stringify(this.menuInfo.btnAuth)
        );
      }
    },
    selectionChangeHandle(e) {
      console.log(e);
    },
    addAuth() {
      this.menuInfo.btnAuth.push({
        isEdit: true,
        permissionName: "",
        permission: "",
      });
    },
    editAuth(row) {
      if (row) {
        row.isEdit = true;
      }
    },
    cancelEditAuth() {
      this.menuInfo.btnAuth = JSON.parse(JSON.stringify(this.menuBtnAuthOrgin));
      this.menuInfo.btnAuth.forEach((el) => {
        el.isEdit = false;
      });
      this.dialogVisible = false;
    },
    saveEditAuth() {
      this.menuInfo.btnAuth.forEach((el) => {
        el.isEdit = false;
      });
      this.dialogVisible = false;
    },
    deleteAuth(row) {
      //  首先需要确定需要删除元素的索引值。
      Array.prototype.indexOf = function (val) {
        for (var i = 0; i < this.length; i++) {
          if (this[i] == val) {
            return i;
          }
        }
        return -1;
      };
      // 根据索引值删除数组中该元素对应的值
      Array.prototype.remove = function (val) {
        var index = this.indexOf(val);
        if (index > -1) {
          this.splice(index, 1);
        }
      };
      console.log(this.menuInfo.btnAuth);
      this.menuInfo.btnAuth.remove(row);
    },
    delMenu() {
      if (this.isDelMenu == false) {
        this.formData.delFlag = "0"; //删除
      } else {
        this.formData.delFlag = "1"; //不删除
      }
    },
    formReset() {
      this.menuInfo = JSON.parse(JSON.stringify(this.selectedNodeData));
      this.formData = {};
    },
    formSave() {
      this.$refs.menuForm.validate((valid) => {
        if (valid) {
          let data = {
            ...this.formData,
          };
          this.$http.post("informationCategory/save", data).then((res) => {
            const { data: resData } = res;
            if (resData.code === 200) {
              this.formData = {};
              this.isDelMenu = false;
              this.getMenuList();
            } else {
              this.$message.error(resData.message);
            }
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    async saveForm() {
      if (this.menuInfo.menuId) {
        const { data: res } = await this.$http.post(
          "menu/update",
          this.menuInfo
        );
        console.log(res, "data");
        if (res.code == 200) {
          this.$message({
            type: "success",
            message: res.message,
          });
        } else {
          this.$message({
            type: "error",
            message: res.message,
          });
        }
        this.getMenuList();
      } else {
        const { data: res } = await this.$http.post(
          "menu/create",
          this.menuInfo
        );
        if (res.code == 200) {
          this.$message({
            type: "success",
            message: res.message,
          });
        } else {
          this.$message({
            type: "error",
            message: res.message,
          });
        }
        this.getMenuList();
      }
      this.getMenuList();
    },
    async getMenuList() {
      //menu/treeList
      const { data: res } = await this.$http.get("informationCategory/list");
      console.log("list");
      console.log(res);
      if (res.code == 200) {
        this.data = treeDataTranslate(res.data.list, "id", "parentId");
      }
    },
  },
  created() {
    this.getMenuList();
  },
};
</script>

<style lang="less" scoped>
.flex-1 {
  flex: 1;
}
.menus-page {
  width: 100%;
  height: 100%;
}

.el-col {
  height: 100%;
}
.newAdd:hover {
  background: #f5f7fa;
}
.btnText:active,
.btnText:focus {
  color: #409eff !important;
}
.menu-list-container {
  padding-right: 10px;
}

.menu-list,
.menu-form {
  height: 100%;
  background: #fff;
  border-radius: 10px;
  padding: 10px;
  overflow: auto;
}

.custom-tree-node {
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  // justify-content: space-between;
  font-size: 14px;
  // padding-right: 8px;
}

.save-btn-container {
  text-align: center;
  padding: 10px;
}
</style>
